import React from 'react';
import { bool, string, func } from 'prop-types';
import { getLinkToSellerPage } from '../../../../utils/getLinkToSellerPage';
import { DOMAIN_SOURCES } from '../../../../constants';

const UserName = ({ withSellerLink = false, username, onSellerLinkClick }) => {
    const sellerLink = getLinkToSellerPage(username, DOMAIN_SOURCES.LOGO_MAKER);

    return (withSellerLink ?
        <a className="user"
            href={sellerLink}
            target="_blank"
            onClick={onSellerLinkClick}
            rel="noreferrer">
            {username}
        </a> :
        <span className="user">{username}</span>);
};

UserName.propTypes = {
    withSellerLink: bool,
    username: string,
    onSellerLinkClick: func
};

export default UserName;
